import { render, staticRenderFns } from "./Mision.vue?vue&type=template&id=34d22c52&"
import script from "./Mision.vue?vue&type=script&lang=js&"
export * from "./Mision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports